import { Instagram, Mail, Phone, MapPin, ShoppingBag, ArrowUpRight } from "lucide-react";

const AMAZON_URL = "https://amzn.in/d/02dgPPzh";

const NAV_GROUPS = [
  {
    heading: "Shop",
    links: [
      { label: "Premium Raw Makhana", href: AMAZON_URL, external: true },
      { label: "Buy on Amazon", href: AMAZON_URL, external: true },
      { label: "Coming on Blinkit", href: "#" },
    ],
  },
  {
    heading: "Brand",
    links: [
      { label: "About Us", href: "#why" },
      { label: "Why Ahaario", href: "#why" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      id="contact"
      className="relative bg-[#13240D] text-white pt-20 md:pt-28 overflow-hidden rounded-t-[2rem] md:rounded-t-[3rem]"
      data-testid="site-footer"
    >
      <div className="absolute inset-0">
        <div className="blob absolute -top-20 right-0 h-80 w-80 rounded-full bg-[#A7D129]/20" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        {/* Links */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pt-4 pb-16">
          <div className="md:col-span-4">
            <a href="#top" className="flex items-center gap-2" data-testid="footer-brand">
              <div className="h-10 w-10 rounded-full bg-[#A7D129] flex items-center justify-center text-[#13240D] font-display font-black text-lg">
                A
              </div>
              <span className="font-display font-extrabold text-2xl">Ahaario</span>
            </a>
            <p className="mt-5 text-white/70 text-sm md:text-base leading-relaxed max-w-sm">
              Premium handpicked makhana from the heartland of Bihar. Healthy
              snacking, made simple.
            </p>
            <div className="mt-6 space-y-3">
              <a
                href="mailto:support@ahaario.com"
                className="flex items-center gap-3 text-white/80 hover:text-[#A7D129] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4" /> support@ahaario.com
              </a>
              <a
                href="tel:+917982154461"
                className="flex items-center gap-3 text-white/80 hover:text-[#A7D129] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="h-4 w-4" /> +91 79821 54461
              </a>
              <p className="flex items-center gap-3 text-white/80">
                <MapPin className="h-4 w-4" /> Made in India
              </p>
            </div>
          </div>

          {NAV_GROUPS.map((g) => (
            <div key={g.heading} className="md:col-span-2">
              <h4 className="font-display font-extrabold uppercase tracking-[0.2em] text-xs text-[#A7D129] mb-5">
                {g.heading}
              </h4>
              <ul className="space-y-3">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      {...(l.external
                        ? { target: "_blank", rel: "noopener noreferrer" }
                        : {})}
                      className="text-white/80 hover:text-[#A7D129] text-sm transition-colors duration-300"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <h4 className="font-display font-extrabold uppercase tracking-[0.2em] text-xs text-[#A7D129] mb-5">
              Follow
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://www.instagram.com/ahaario/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white/80 hover:text-[#A7D129] text-sm transition-colors"
                  data-testid="footer-instagram"
                >
                  <Instagram className="h-4 w-4" /> Instagram
                </a>
              </li>
              <li>
                <a
                  href={AMAZON_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white/80 hover:text-[#A7D129] text-sm transition-colors"
                  data-testid="footer-amazon"
                >
                  <ShoppingBag className="h-4 w-4" /> Amazon
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Massive watermark */}
        <div className="relative pb-10">
          <p className="font-display font-black text-[#A7D129]/15 text-[18vw] md:text-[14vw] lg:text-[12vw] leading-none tracking-tighter select-none pointer-events-none">
            Ahaario
          </p>
        </div>

        <div className="border-t border-white/10 py-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/60">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} Ahaario™. All rights reserved.
          </p>
          <p>Crafted with care in India 🌿</p>
        </div>
      </div>
    </footer>
  );
}
